import { isEmpty } from "lodash-es";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { IEditableSectionRenderProps } from "@/components/EditableSection";
import { Header } from "@/components/Header";
import { Text } from "@/components/Text";
import { Flex, Section } from "@/eworkitComponents";
import { ProfileSkills } from "@/views/components/ConsultantProfile/Partials/ProfileSkills";
import { IConsultantProfileSectionProps } from "@/views/components/ConsultantProfile/Sections/types";
import { ConsultantProfileSkillsEdit } from "@/views/ConsultantProfiles/Detail/SkillsSection/SkillsForm";

interface Props extends IConsultantProfileSectionProps, IEditableSectionRenderProps {}

export const SkillsSection: FunctionComponent<Props> = ({ editableProps, onUpdate, record }) => {
  const { t } = useTranslation("session");
  const isListEmpty = isEmpty(record.skills);

  return (
    <Section grow={1} direction="column" innerMargin="md" testName="skills">
      <Flex
        direction="row"
        justify="space-between"
        margin={[false, "lg", false, false]}
        padding={[false, "md", false, false]}
        innerMargin="md">
        <Header size="sm" color="black" weight="bold">
          {t("CONSULTANT_PROFILES.DETAIL.SKILLS.SECTION_HEADER")}
        </Header>
      </Flex>
      <Flex grow={1} innerMargin="sm">
        {editableProps.editMode ? (
          <ConsultantProfileSkillsEdit
            source={record}
            initialValues={{ skills: record.skills }}
            onUpdate={onUpdate}
            onCancel={editableProps.handleCancelClick}
            editableProps={editableProps}
          />
        ) : isListEmpty ? (
          <Text size="md" color="grey3">
            {t("CONSULTANT_PROFILES.DETAIL.SKILLS.NO_ITEMS")}
          </Text>
        ) : (
          <ProfileSkills profile={record} />
        )}
      </Flex>
    </Section>
  );
};
